import { CanonicalPlugin, InferSeoMetaPlugin } from "@unhead/vue/plugins";
import { pageTitleFromDocumentTitle } from "@carnet/ui/utils/documentTitle";

export function seoHeadPlugins(siteOrigin: string) {
  return [
    CanonicalPlugin({ canonicalHost: siteOrigin }),
    InferSeoMetaPlugin({ ogTitle: (documentTitle) => pageTitleFromDocumentTitle(documentTitle ?? "") }),
  ];
}
